<template>
    <!-- Adding New Branch for Company and Its Modal Popup -->
    <div>
        <modal class="new-modal-small" :name="modal_name" transition="nice-modal-fade" :delay="100" height="auto" :min-height="200"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="false"
        style="pointer-events:inherit !important" 
        v-bind:click-to-close="false">
			<div class="v-modal-content" style="background-color: #eff1f4 !important;">
				<div class="v-modal-header">
                    <div>
					    <span class="v-modal-dialog-title v-modal-title headerPositionSmall">ADD NEW BRANCH</span>
                    </div>
                    <div>    
					    <span class="icon icon-close mr-2 text-lightblack pointer" @click="hideBranchtNew()"></span>
                    </div>    
				</div>
				<div class="v-modal-body">
					<div class="v-modal-layout">
                        <div class="px-4">
                            <div class="form-group">
                                <input class="inputField" name="branch_name" v-validate="'required'" v-model="name" style="margin-top:5px;" type="text" placeholder="Enter Branch Name" required>
                                <span class="inputBorder"></span>
                                <label class="inputLabel fs-14 fw-600" style="top: 0px !important;">Branch Name</label>
                            </div>
                            <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('branch_name')">Branch Name is Required</span>
                            <div class="row mt-7 mb-3">
                                <div class="col-lg-12 text-center">
                                    <button type="button" class="btn btn-danger btn-smm mr-3" @click="hideBranchtNew()" style="box-shadow: none;">CANCEL</button>
                                    <button type="button" class="btn btn-success text-white btn-smm" style="box-shadow: none;" @click="saveBranchNew(name)">SAVE</button>
                                </div>
                            </div>
                        </div>
					</div>
				</div>
			</div>
		</modal>
    </div>

</template>
<script>
import { EventBus } from "./eventBus/nav-bar-event.js";
export default {
    data() {
        return {
            name:''
        }
    },
    props: ['modal_name'],
    mounted() {
    },
    methods: {
        hideBranchtNew() {
            this.name = ''
            this.$modal.hide(this.modal_name);
        },
        saveBranchNew(name){
            this.$validator.validateAll().then(result => {
                if(result){
                    EventBus.$emit('storeBranch',name)
                    this.$modal.hide(this.modal_name);
                    this.name = ''
                }
            })
        }
    },
};    
</script>


// WEBPACK FOOTER //
// src/components/BranchNewModal.vue